import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import { LOGOUT_URL } from '../../client_url_constant'

const red = '#bb0000'
const grey ='#a2afb9'

const styles = theme => ({
  button: {
    margin: 5,
    fontSize: 12,
    textAlign:'center',
    position:'absolute',
    right:100,
    top: 0,
    zIndex:10000,
    backgroundColor:red,
    color:'#ffffff'
  },
  input: {
    display: 'none',
  },
});

class LogoutButton extends Component {
  constructor(props){
    super(props)
    this.logout = this.logout.bind(this)
  }
logout(){
  window.open('','_self').close();
  //sessionStorage.removeItem('ad_tst_ref');
}

  render(){
  const { classes } = this.props;
  return (
    <div>
      <Button variant="outlined" color={grey} href={ LOGOUT_URL } className={classes.button} onClick={this.logout}>
        Sign Out
      </Button>
    </div>
  );
}
}


LogoutButton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LogoutButton);



// WEBPACK FOOTER //
// ./src/components/general/LogoutButton.js